// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-speed-dial[data-v-c7c08fe8] .pdd{padding:8px!important}", ""]);
// Exports
module.exports = exports;
